import {
    FETCH_REPORTS_FULFILLED,
    FETCH_REPORTS_PENDING,
    FETCH_REPORTS_REJECTED,
} from '../Actions/ReportActions';

import moment from 'moment';

// Initialise State
const initialState = {
    reports: [],
    fetchingReports: false,
    fetchedReports: false,
    failedToFetchReports: false,
};

// Reducer
export const ReportsReducer = (state = initialState, action) => {

    switch(action.type) {
        case FETCH_REPORTS_PENDING:
            return {
                ...state,
                fetchingReports: true,
                fetchedReports: false,
                failedToFetchReports: false
            };
        case FETCH_REPORTS_FULFILLED:
            return {
                ...state,
                reports: action.payload,
                fetchingReports: false,
                fetchedReports: true,
                failedToFetchReports: false
            };
        case FETCH_REPORTS_REJECTED:
            return {
                ...state,
                fetchingReports: false,
                fetchedReports: false,
                failedToFetchReports: true
            };
        default:
            return state;
    }
};